/* Map */
import "./map.scss";
import "@popperjs/core";
import DataTable from 'datatables.net-dt';
import * as bootstrap from 'bootstrap';
window.bootstrap = bootstrap;
import * as maplibregl from 'maplibre-gl';
import 'maplibre-gl/dist/maplibre-gl.css';
import { Map } from 'maplibre-gl';
import HikeMapLayer from "./hikeMapLayer";
import BasemapControl from 'maplibre-basemaps';
import MaplibreGeocoder from '@maplibre/maplibre-gl-geocoder';
import '@maplibre/maplibre-gl-geocoder/dist/maplibre-gl-geocoder.css';
import { createGeocoderApi } from './geocoder.js';
import { isSeanMode } from './common_utils.js';
import {
  MaplibreExportControl,
  Size,
  PageOrientation,
  Format,
  DPI
} from '@watergis/maplibre-gl-export';


/* Datatables */
import "datatables.net";
import "datatables.net-bs5";
import "datatables.net-responsive-bs5";
// require("../images/logo.png");

let logDev = false;
let hikeApiBaseUrl = "./api";

if (DEVMODEFLAG === true) {
  logDev = true;
  console.log("logDev: " + logDev);
  hikeApiBaseUrl = "http://127.0.0.1:5000";
  //hikeApiBaseUrl = "https://www.fkylewright.com/hikes/api";
  console.log("hikeApiBaseUrl: " + hikeApiBaseUrl);
} else {
  console.log("map production mode.");
}

// Sean-mode detection and data source selection:
const seanMode = isSeanMode();
let hikesApiUrl = '/hikes';
let bpsApiUrl = '/bps';
let dataTitle = 'Interactive map of my day hikes and backpacking trips';
let pageTitle = 'fkylewright.com - Hikes Map';

if (seanMode) {
  hikesApiUrl = '/hikes/sean';
  bpsApiUrl = '/bps/sean';
  dataTitle = "Sean's day hikes and backpacking trips";
  pageTitle = 'fkylewright.com - Hikes Map - Sean Only';
}

// initial dataTables references:
var dTableHikes;
var dTableBackpacks;
var cachedBackpacksData = null;
var hikesTableInitialized = false;
var backpacksTableInitialized = false;

/**
 * Calculate available pixel height for a DataTable inside the offcanvas tab pane.
 * Subtracts offcanvas-header, tab bar, and pane wrapper padding from body height.
 */
function getTableHeight() {
  var offcanvas = document.getElementById("offcanvasBottom");
  var body = offcanvas ? offcanvas.querySelector(".offcanvas-body") : null;
  if (!body) return 300; // conservative fallback

  var totalH = body.offsetHeight;

  // Subtract offcanvas header (flex-shrink: 0, fixed)
  var header = offcanvas.querySelector(".offcanvas-header");
  if (header) totalH -= header.offsetHeight;

  // Subtract tab bar: margin-top + offset height
  var tabs = document.getElementById("dataTableTabs");
  if (tabs) {
    var mt = parseInt(getComputedStyle(tabs).marginTop) || 0;
    totalH -= mt + tabs.offsetHeight;
  }

  // Subtract tab-pane top/bottom padding and inner-wrap top/bottom padding
  // (1rem pane padding + 0 inner-wrap padding = 2rem = ~32px)
  totalH -= 32;

  return Math.max(totalH, 150); // minimum reasonable height
}

/**
 * Resize all initialized DataTables to fill the available offcanvas space.
 */
function resizeTables() {
  var offcanvas = document.getElementById("offcanvasBottom");
  if (!offcanvas || !offcanvas.classList.contains("show")) return;

  var h = getTableHeight();

  if (dTableHikes && dTableHikes.settings().length > 0) {
    var scrollBodyH = dTableHikes.table().node().closest('.dataTables_scroll')?.querySelector('.dataTables_scrollBody');
    if (scrollBodyH) scrollBodyH.style.height = h + 'px';
    dTableHikes.columns.adjust().draw(false);
  }
  if (dTableBackpacks) {
    var scrollBodyB = dTableBackpacks.table().node().closest('.dataTables_scroll')?.querySelector('.dataTables_scrollBody');
    if (scrollBodyB) scrollBodyB.style.height = h + 'px';
    dTableBackpacks.columns.adjust().draw(false);
  }
}

const mapAttribTextOsm =
  '<a href="http://openstreetmap.org">OpenStreetMap</a>';
const myAccessTokenMapBox =
  "pk.eyJ1Ijoid3lsZWsiLCJhIjoiY2pmb3cwdjFmMGZ0NDMzc25sMDc0ZW9xOCJ9.KjJF7Xa5NLgsomjz0ovkaA";
const myAccessTokenMapTiler = "JNu3UX54avfjLJHkHnoC";

// Define the available base layers:
const baseLayerDark = {
  name: "Dark (Mapbox)",
  'type': 'raster',
  'tiles': ["https://api.mapbox.com/styles/v1/mapbox/dark-v11/tiles/{z}/{x}/{y}?access_token=" + myAccessTokenMapBox],
  'tileSize': 512,
  'maxZoom': 18,
  'zoomOffset': -1,
}
const baseLayerStreets = {
  name: "Streets (Mapbox)",
  "type": "tiles",
  "tiles": ["https://api.mapbox.com/styles/v1/mapbox/streets-v11/tiles/{z}/{x}/{y}?access_token=" + myAccessTokenMapBox],
  'tileSize': 512,
  'maxZoom': 18,
  'zoomOffset': -1,
};
const baseLayerSatellite = {
  name: "Satellite (Mapbox)",
  'type': 'raster',
  tiles: ["https://api.mapbox.com/styles/v1/mapbox/satellite-v9/tiles/{z}/{x}/{y}?access_token=" + myAccessTokenMapBox],
  'tileSize': 512,
  'maxZoom': 18,
  'zoomOffset': -1,
};
const osm = {
  name: "OSM",
  tiles: ['https://tile.openstreetmap.org/{z}/{x}/{y}.png'],
  maxzoom: 18,
  attribution: mapAttribTextOsm
}
const osmCycle = {
  name: "OSM Cycle",
  tiles: ['https://a.tile-cyclosm.openstreetmap.fr/cyclosm/{z}/{x}/{y}.png'],
  attribution: mapAttribTextOsm
}
const esriTerrain = {
  name: "Esri Terrain",
  tiles: ['https://server.arcgisonline.com/ArcGIS/rest/services/World_Terrain_Base/MapServer/tile/{z}/{y}/{x}'],
  maxzoom: 13,
  attribution: 'Tiles &copy; Esri &mdash; Source: USGS, Esri, TANA, DeLorme, and NPS',
}
const baseLayers = {
  baseLayerStreets,
  baseLayerSatellite,
  osm,
  osmCycle,
  esriTerrain,
  baseLayerDark
}

// Empty map reference:
let myMap;

function formatThousands(num) {
  let values = num.toString().split(".");
  return (
    values[0].replace(/.(?=(?:.{3})+$)/g, "$&,") +
    (values.length == 2 ? "." + values[1] : "")
  );
}

function goToHike(lat, long) {
  if (!myMap) return;

  // Close the offcanvas (drawer): dispatch a native click event 
  // — bubbles up to Bootstrap's document-level delegation handler
  // for data-bs-dismiss="offcanvas".
  const closeBtn = document.getElementById("offcanvasBottomCloseBtn");
  if (closeBtn) {
    closeBtn.dispatchEvent(new MouseEvent('click', { bubbles: true }));
  }

  // Fly the map to the chosen coords:
  myMap.flyTo({
    center: [Number(long), Number(lat)],
    zoom: 12,
    essential: true // this animation is considered essential with respect to prefers-reduced-motion
  });
}

/**
 * Generate HTML content for a hike popup.
 * @param {Object} h - Hike data object (Type, Name, Location, Country, Month,
 *   Year, Distance, ElevationGain, Duration, Terminus, URL, URL_WTA)
 * @returns {string} Complete popup HTML string
 */
function renderPopupHtml(h) {
  // Guard against null/undefined hike data
  if (!h?.Type) return '';
  const typeClass = 'popup-type-' + h.Type.toLowerCase();
  let html = '';

  // Card container with type color class
  html += '<div class="popup-card ' + typeClass + '">';

  // Type header bar
  html += '<div class="popup-header">';
  html += '<span class="popup-header-label">' + h.Type + '</span>';
  html += '</div>';

  // Hike name
  html += '<h4 class="popup-name">' + h.Name + '</h4>';

  // Location line (if available)
  const locationParts = [];
  if (h.Location && h.Location.trim() !== '') {
    locationParts.push(h.Location);
  }
  if (h.Country && h.Country.trim() !== '') {
    locationParts.push(h.Country);
  }
  if (locationParts.length > 0) {
    html += '<div class="popup-location">';
    html += '<iconify-icon icon="tabler:map-pin" inline class="popup-stat-icon"></iconify-icon>&nbsp;';
    html += locationParts.join(' · ');
    html += '</div>';
  }

  // Links (Blog / WTA)
  const blogActive = !!(h.URL && h.URL.trim() !== '');
  const wtaActive = !!(h.URL_WTA && h.URL_WTA.trim() !== '');
  if (blogActive || wtaActive) {
    html += '<div class="popup-links">';
    if (blogActive) {
      html += '<a href="' + h.URL + '" target="_blank" rel="noopener noreferrer"><iconify-icon icon="tabler:link" inline></iconify-icon> Blog</a>';
    }
    if (wtaActive) {
      html += '<a href="' + h.URL_WTA + '" target="_blank" rel="nofollow"><iconify-icon icon="tabler:external-link" inline></iconify-icon> WTA</a>';
    }
    html += '</div>';
  }

  // Stats grid
  html += '<div class="popup-stats-grid">';
  html += '<div class="popup-stat-row">';
  html += '<iconify-icon icon="tabler:calendar" inline class="popup-stat-icon"></iconify-icon>';  
  html += '<span class="popup-stat-label">Date</span>';
  html += '<span class="popup-stat-value">' + (h.Month?.substr(0, 3) || '') + ' ' + h.Year + '</span>';
  html += '</div>';

  html += '<div class="popup-stat-row">';
  html += '<iconify-icon icon="tabler:clock" inline class="popup-stat-icon"></iconify-icon>';
  html += '<span class="popup-stat-label">Time</span>';
  html += '<span class="popup-stat-value">' + h.Duration + '</span>';
  html += '</div>';

  html += '<div class="popup-stat-row">';
  html += '<iconify-icon icon="tabler:ruler" inline class="popup-stat-icon"></iconify-icon>';
  html += '<span class="popup-stat-label">Dist.</span>';
  html += '<span class="popup-stat-value">' + h.Distance + ' mi.</span>';
  html += '</div>';

  html += '<div class="popup-stat-row">';
  html += '<iconify-icon icon="tabler:mountain" inline class="popup-stat-icon"></iconify-icon>';
  html += '<span class="popup-stat-label">EG</span>';
  html += '<span class="popup-stat-value">' + h.ElevationGain + ' ft.</span>';
  html += '</div>';

  if (h.Terminus && h.Terminus.length > 0) {
    html += '<div class="popup-stat-row">';
    html += '<iconify-icon icon="tabler:flag" inline class="popup-stat-icon"></iconify-icon>';
    html += '<span class="popup-stat-label">Terminus</span>';
    html += '<span class="popup-stat-value">' + h.Terminus + '</span>';
    html += '</div>';
  }

  html += '</div> <!-- /popup-stats-grid -->';
  html += '</div> <!-- /popup-card -->';

  return html;
}

function buildPopup(h, dataAll) {
  // if (logDev) console.log("buildPopup > DEBUG > ", h, dataAll);
  if (h.Latitude < -90 || h.Latitude > 90) {
    if (logDev) console.log("buildPopup > DEBUG > Bad Latitude value: ", h);
    return;
  }

  // Generate popup HTML content
  const html = renderPopupHtml(h);
  const customOptions = {
    minWidth: 200,
    className: "hikePopup",
  };
  let popup = new maplibregl.Popup({ closeOnClick: true, offset: { bottom: [0, -41] } })
    .setHTML(html);

  // add to appropriate layer based on hike type:
  if (h.Type === "Hike") {
    let hikeIconMarker = document.createElement('div');
    hikeIconMarker.className = 'marker marker-hike';
    let marker = new maplibregl.Marker({ element: hikeIconMarker, anchor: "bottom" })
      .setLngLat([h.Longitude, h.Latitude])
      .setPopup(popup)
      .addTo(myMap);
    // process on the dayhikes layer:
    dataAll.addHike(
      h.Type,
      h.Year,
      h.Latitude,
      h.Longitude,
      Number(h.Distance),
      Number(h.ElevationGain),
      h.Name,
      html,
      marker
    );
  } else if (h.Type === "Walk") {
    let walkIconMarker = document.createElement('div');
    walkIconMarker.className = 'marker marker-walk';
    let marker = new maplibregl.Marker({ element: walkIconMarker, anchor: "bottom" })
      .setLngLat([h.Longitude, h.Latitude])
      .setPopup(popup)
      .addTo(myMap);

    // process on the dayhikes layer:
    dataAll.addHike(
      h.Type,
      h.Year,
      h.Latitude,
      h.Longitude,
      Number(h.Distance),
      Number(h.ElevationGain),
      h.Name,
      html,
      marker
    );
  } else if (h.Type === "Backpack") {
    let bpIconMarker = document.createElement('div');
    bpIconMarker.className = 'marker marker-bp';
    let marker = new maplibregl.Marker({ element: bpIconMarker, anchor: "bottom", offset: [0, 12] })
      .setLngLat([h.Longitude, h.Latitude])
      .setPopup(popup)
      .addTo(myMap);
    // process on the backpacks layer:
    dataAll.addHike(
      h.Type,
      h.Year,
      h.Latitude,
      h.Longitude,
      Number(h.Distance),
      Number(h.ElevationGain),
      h.Name,
      html,
      marker
    );
  } else {
    if (logDev)
      console.log("buildPopup > ERROR > Unknown hike type: " + h.Name);
  }
}

function initialMap() {
  // first, reset the map:
  if (myMap) myMap.remove();

  // prepare the initial map and options:
  myMap = new Map({
    container: 'HikeMap',
    center: [-122.4821479, 47.6129432],
    zoom: 6
  });

  // Add geocode search control (Nominatim via shared geocoder):
  if (logDev) console.log("drawMap > adding Geocoder (search) control to map...");
  const geocoderApi = createGeocoderApi();
  myMap.addControl(
    new MaplibreGeocoder(geocoderApi, {
      maplibregl
    })
  );

  // Add navigation control
  if (logDev) console.log("drawMap > adding navigation control to map...");
  myMap.addControl(new maplibregl.NavigationControl());

  // Base layers control: 
  const basemapControl = new BasemapControl(
    {
      basemaps: baseLayers,
      initialBasemap: "baseLayerStreets",
      height: '175px', //default: 100px
      width: '190px' //default: 150px 
    }
  );
  if (logDev) console.log("drawMap > adding base layers control to map...");
  myMap.addControl(basemapControl, 'top-right');

  // Add fullscreen map control:
  if (logDev) console.log("drawMap > adding fullscreen control to map...");
  myMap.addControl(new maplibregl.FullscreenControl());

  // add an export control:
  const exportControl = new MaplibreExportControl({
    PageSize: Size.A3,
    PageOrientation: PageOrientation.Portrait,
    Format: Format.PNG,
    DPI: DPI[96],
    Crosshair: true,
    PrintableArea: true,
    Local: 'en',

  });
  if (logDev) console.log("drawMap > adding export control to map...");
  myMap.addControl(exportControl, 'top-right');

  myMap.on('load', () => {
    // TODO: ??
  });
}

function drawMapData(data) {
  // Define the available data layers:
  let allHikesLayer = new HikeMapLayer("All Hikes");

  // get a list of hike type values from the resultset:
  let mapLayerHikeTypes = [...new Set(data.map((x) => x.Type))];
  if (logDev) {
    console.log("drawMap > starting type: ", data);
    console.log("drawMap > mapLayerHikeTypes: ", mapLayerHikeTypes);
  }

  // for each hike type present, build a layer and add it to the parent layer group:
  mapLayerHikeTypes.forEach((currType) => {
    // 1. reduce the original dataset by the current hike type:
    let currTypeData = data.filter((d) => d.Type === currType);

    if (logDev) {
      console.log("drawMap > type: ", currType, " currTypeData: ", currTypeData);
    }

    // 2. construct popups for each entry with this hike type:
    currTypeData.forEach((data) => {
      // build the popup for this hike:
      buildPopup(data, allHikesLayer);
    });
    if (logDev)
      console.log("popups ready. allHikesLayer is now: ", allHikesLayer);
  });

  // calculate the default boundary of the default coords:
  let currCoords = allHikesLayer.getCoords();
  if (logDev) {
    console.log("calculating default map bounds...");
    console.log(currCoords);
  }

  // add stats content below the map:
  if (logDev) console.log("adding stats content below the map...");

  // Show loading indicator while calculating stats
  showStatsLoading();

  let currStatDist = allHikesLayer.getDist();
  let currStatElev = allHikesLayer.getElev();
  loadStatsBar(currStatDist, currStatElev);

  if (logDev) console.log("attaching event listeners...");

  myMap.on("overlayadd", function (ev) {
    // recalculate stats for the stats bar:
    if (logDev) {
      console.log("adding " + ev.name);
    }
    currStatDist += allHikesLayer.getSumDistType(ev.name);
    currStatElev += allHikesLayer.getSumElevType(ev.name);
    loadStatsBar(currStatDist, currStatElev);
  });
  myMap.on("overlayremove", function (ev) {
    // recalculate stats for the stats bar:
    if (logDev) {
      console.log("removing " + ev.name);
      console.log(
        "subtracting distance: " + allHikesLayer.getSumDistType(ev.name), " subtracting elev. gain: " + allHikesLayer.getSumElevType(ev.name)
      );
    }
    currStatDist -= allHikesLayer.getSumDistType(ev.name);
    currStatElev -= allHikesLayer.getSumElevType(ev.name);
    loadStatsBar(currStatDist, currStatElev);

    // Customize scrollwheel zoom behavior to require user focus:
    myMap.on("focus", function () {
      myMap.scrollWheelZoom.enable();
    });
    myMap.on("blur", function () {
      myMap.scrollWheelZoom.disable();
    });
  });

  // drawMap complete.
}

async function drawTableHikes(xhr) {
  // Now load the datatable below the map:
  dTableHikes = new DataTable('#HikeTable', {
    data: xhr,
    paging: true,
    pageLength: 7,
    lengthChange: false,
    info: false,
    scrollY: getTableHeight() + "px",
    scrollCollapse: true,
    stateSave: true,
    order: [[3, 'desc']],
    columns: [
      {
        data: "Name",
        width: "25%",
        render: function (data, type, row, meta) {
          // check for URL value:
          if (row.URL) {
            return (
              '<a href="' +
              row.URL +
              '" target="_blank">' +
              data +
              '</a>&nbsp;<iconify-icon icon="tabler:zoom-scan" class="mapFlyTo" inline></iconify-icon>'
            );
          } else {
            return (
              data + '&nbsp;<iconify-icon icon="tabler:zoom-scan" class="mapFlyTo" inline></iconify-icon>'
            );
          }
        },
      },
      {
        data: "Location",
      },
      {
        data: "Country",
      },
      {
        data: "Date",

        /*className: "mapFlyTo"*/
      },
      {
        data: "Month",
        visible: false,
      },
      {
        data: "Year",
        visible: false,
      },
      {
        data: "Type",
        render: function (data, type, row, meta) {
          if (data === "Hike") {
            return '<iconify-icon icon="fa-solid:hiking" inline></iconify-icon>&nbsp;Hike';
          } else if (data === "Walk") {
            return '<iconify-icon icon="mdi:walk" inline></iconify-icon>&nbsp;Walk';
          } else if (data === "Backpack") {
            return '<iconify-icon icon="emojione:tent" inline></iconify-icon>&nbsp;Backpack';
          } else {
            return '<iconify-icon icon="fluent-mdl2:unknown" inline></iconify-icon>&nbsp;Unknown';
          }
        },
      },
      {
        data: "Distance",
        render: function (data) { return Number(data).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ","); },
        className: "text-right",
      },
      {
        data: "ElevationGain",
        render: function (data) { return Number(data).toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ","); },
        className: "text-right",
      },
      {
        data: "Latitude",
        visible: false,
      },
      {
        data: "Longitude",
        visible: false,
      },
      {
        data: "Terminus",
      },
    ],
    initComplete: function () {
      // show the datatable and hide the loading msg:
      document.getElementById("HikeTableLoading").style.display = "none";
      const innerWrap = document.querySelector(".datatable-inner-wrap");
      if (innerWrap) innerWrap.style.display = '';

      // Delegated click handler for the "fly-to" icon in the Name column.
      const tableBody = document.querySelector("#HikeTable tbody");
      if (tableBody) {
        tableBody.addEventListener("click", function (e) {
          const icon = e.target.closest("iconify-icon.mapFlyTo");
          if (!icon) return;
          const parentRow = icon.closest("tr");
          if (!parentRow) return;
          const rowData = dTableHikes.row(parentRow).data();
          if (logDev)
            console.log(
              "Lat: " + rowData.Latitude + " Long: " + rowData.Longitude
            );
          goToHike(rowData.Latitude, rowData.Longitude);
        });
      }
    },
  });
}

async function drawTableBackpacks(xhr) {
  // Now load the datatable below the map:
    dTableBackpacks = new DataTable('#BackpackTable', {
    data: xhr,
    paging: true,
    pageLength: 7,
    lengthChange: false,
    info: false,
    scrollY: getTableHeight() + "px",
    scrollCollapse: true,
    stateSave: true,
    order: [[3, 'desc']],
    columns: [
      {
        data: "Name",
        width: "25%",
        render: function (data, type, row, meta) {
          return '<a href="' + row.URL + '" target="_blank">' + data + "</a>";
        },
        responsivePriority: 1,
      },
      {
        data: "Location",
        responsivePriority: 5,
      },
      {
        data: "Country",
        responsivePriority: 2,
      },
      {
        data: "StartDate",
        responsivePriority: 3,
      },
      {
        data: "EndDate",
        responsivePriority: 6,
      },
      {
        data: "Duration",
        responsivePriority: 7,
      },
      {
        data: "HikeCount",
        responsivePriority: 7,
      },
      {
        data: "TotalDist",
        render: function (data) { return Number(data).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ","); },
        className: "text-right",
        responsivePriority: 4,
      },
      {
        data: "TotalElevGain",
        render: function (data) { return Number(data).toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ","); },
        className: "text-right",
        responsivePriority: 8,
      },
      {
        data: "Comments",
        visible: false,
      },
    ],
    initComplete: function () {
      // show the datatable and hide the loading msg:
      document.getElementById("BackpackTableLoading").style.display = "none";
      const innerWrap = document.querySelector(".datatable-inner-wrap");
      if (innerWrap) innerWrap.style.display = '';

      // Resize table now that the wrapper is visible and container has dimensions.
      resizeTables();
    },
  });
}

async function loadStatsBar(d, e) {
  // Hide the loading spinner and show the stats content
  const statsLoadingSpinner = document.getElementById("statsLoadingSpinner");
  const statsContainer = document.getElementById("statsBar");

  if (statsLoadingSpinner) {
    statsLoadingSpinner.style.display = "none";
  }

  if (statsContainer) {
    statsContainer.innerHTML =
      "Total distance: " +
      formatThousands(d.toFixed(2)) +
      " mi. | Total elevation: " +
      formatThousands(e) +
      " ft.";
  }
}

function showStatsLoading() {
  // Show the loading spinner for stats
  const statsLoadingSpinner = document.getElementById("statsLoadingSpinner");

  if (statsLoadingSpinner) {
    statsLoadingSpinner.style.display = "flex";
  }
}

function showDataButtonLoading() {
  const button = document.getElementById('ShowDataBtn');
  const buttonText = document.getElementById('ShowDataBtnText');
  const buttonSpinner = document.getElementById('ShowDataBtnSpinner');

  // Show spinner and hide text
  buttonText.classList.add('d-none');
  buttonSpinner.classList.remove('d-none');

  // Disable the button to prevent multiple clicks
  button.disabled = true;
}

function showDataButtonReady() {
  const button = document.getElementById('ShowDataBtn');
  const buttonText = document.getElementById('ShowDataBtnText');
  const buttonSpinner = document.getElementById('ShowDataBtnSpinner');

  // Show text and hide spinner
  buttonText.classList.remove('d-none');
  buttonSpinner.classList.add('d-none');

  // Re-enable the button
  button.disabled = false;
}

async function fetchMapData(url) {
  if (logDev) console.log("Begin fetchMapData for url: %s.", url);

  const ops = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
    cache: "default",
  };

  try {
    const response = await fetch(url, ops);
    const apiData = await response;
    if (apiData.ok) {
      if (logDev) console.log("fetchMapData for url: %s.", url, " OK.");
      return apiData.json();
    }
    else {
      if (logDev) console.log("fetchMapData for url: %s.", url, " not OK.");
      return null;
    }
  } catch (e) {
    if (logDev) console.log("Error in fetchMapData: %s.", e);
    return null;
  }
}

// Add event listener to handle button click and show loading state
const showDataBtn = document.getElementById('ShowDataBtn');
if (showDataBtn) {
  showDataBtn.addEventListener('click', function () {
    // Show loading state when button is clicked
    showDataButtonLoading();

    // After a short delay, reset to ready state (simulating async operation)
    setTimeout(function () {
      showDataButtonReady();
    }, 1000);
  });
}

// Timeout constant for initial map data load (90 seconds)
const DATA_LOAD_TIMEOUT_MS = 90000;

// Module-level reference to cached hike data (used by retry function)
var cachedHikesData = null;

/**
 * Show the timeout error message in the stats bar, replacing the loading spinner.
 * Hides the spinner and displays a message with a reload button.
 */
function showTimeoutError() {
  // Hide the loading spinner (use both class + inline for Safari reliability)
  const spinner = document.getElementById("statsLoadingSpinner");
  if (spinner) {
    spinner.classList.add("d-none");
    spinner.style.display = "none";
  }

  // Disable the Show Data button
  const btn = document.getElementById("ShowDataBtn");
  if (btn) btn.disabled = true;

  // Show the timeout error message with reload button
  const errorEl = document.getElementById("statsTimeoutError");
  if (errorEl) {
    errorEl.classList.remove("d-none");
    errorEl.classList.add("d-flex");
    errorEl.style.display = "flex";
  }
}

/**
 * Retry loading the map data. Clears the error state and re-fetches.
 */
function retryMapDataLoad() {
  // Clear error state
  const spinner = document.getElementById("statsLoadingSpinner");
  if (spinner) {
    spinner.classList.remove("d-none");
    spinner.style.display = "flex";
  }

  const errorEl = document.getElementById("statsTimeoutError");
  if (errorEl) {
    errorEl.classList.add("d-none");
    errorEl.classList.remove("d-flex");
    errorEl.style.display = "none";
  }

  // Re-fetch map data
  fetchMapData(hikeApiBaseUrl + hikesApiUrl).then(function (json) {
    if (json !== null) {
      cachedHikesData = json;
      drawMapData(json);
    } else {
      throw new Error("Empty response");
    }
  }).catch(function (err) {
    if (logDev) console.error(err);
    showTimeoutError();
  });
}

// IIFE to initialize the map and fetch data on page load
(function () {
  // Apply Sean-mode UI changes
  if (seanMode) {
    document.title = pageTitle;
    const badge = document.getElementById('seanBadge');
    if (badge) {
      badge.classList.remove('d-none');
    }
    const descText = document.getElementById('map-description-text');
    if (descText) {
      descText.textContent = dataTitle;
    }
  }

  // initialize the map (to display something while fetching data)...
  initialMap();

  // obtain map data from the hikes API with a timeout:
  // (cachedHikesData is declared at module level so retryMapDataLoad can access it)
  var mapDataPromise = Promise.race([
    fetchMapData(hikeApiBaseUrl + hikesApiUrl).then((json) => {
      if (json === null) {
        // API returned null (HTTP error, network failure, etc.) — reject to
        // trigger the shared error handler (spinner → error UI + reload btn).
        return Promise.reject(new Error("Map data response was empty"));
      }
      // Cache data for both the map and the Hikes datatable
      cachedHikesData = json;
      // Render the map only (Hikes table deferred to offcanvas open event)
      drawMapData(json);
    }),
    new Promise(function (_, reject) {
      setTimeout(function () {
        reject(new Error("Map data load timed out"));
      }, DATA_LOAD_TIMEOUT_MS);
    })
  ])
    .catch(function (err) {
      if (logDev) console.error(err);
      showTimeoutError();
    });

  // Wire up reload button click handler
  const retryBtn = document.getElementById("RetryDataLoadBtn");
  if (retryBtn) {
    retryBtn.addEventListener("click", function () {
      if (logDev) console.log("Retrying map data load...");
      retryMapDataLoad();
    });
  }

  const bottomOffcanvas = document.getElementById("offcanvasBottom");
  if (bottomOffcanvas) {
    bottomOffcanvas.addEventListener("shown.bs.offcanvas", (event) => {
      // Initialize Hikes table when offcanvas opens — ensures container
      // has correct dimensions instead of zero height from hidden state.
      if (cachedHikesData && !hikesTableInitialized) {
        hikesTableInitialized = true;
        drawTableHikes(cachedHikesData);
        // Ensure the hikes table fills available space after initialization.
        resizeTables();
      }
    });

    // Handle the edge case where the offcanvas is already open on page load
    // (e.g., browser session restore). Bootstrap won't fire the shown event.
    if (bottomOffcanvas.classList.contains("show")) {
      if (logDev)
        console.log("offcanvas already open on page load, initializing tables");
      if (cachedHikesData && !hikesTableInitialized) {
        hikesTableInitialized = true;
        drawTableHikes(cachedHikesData);
        resizeTables();
      }
    }

    // Recalculate table height and initialize hidden tables when user
    // switches tabs inside the offcanvas. Crucial: the backpacks table
    // must be initialized only when its tab is visible — initializing
    // it while hidden (display:none) causes DataTables to measure zero-
    // width columns, resulting in "No data available in table" on page 1.
    document.getElementById("dataTableTabs").addEventListener(
      "shown.bs.tab",
      function (ev) {
        // ev.target may be the button or an element inside it (iconify-icon,
        // text node, etc.), so use closest() to find the actual tab button.
        const clickedTab = ev.target.closest('[data-bs-toggle="tab"]');
        if (!clickedTab) return;

        // Initialize backpacks table when its tab is first shown
        if (clickedTab.id === "backpacks-tab" && !backpacksTableInitialized) {
          fetchMapData(hikeApiBaseUrl + bpsApiUrl).then((json) => {
            if (json !== null) {
              backpacksTableInitialized = true;
              drawTableBackpacks(json);
            }
          });
        }
        // Recalculate heights for both tables after tab switch
        resizeTables();
      }
    );
  } else {
    if (logDev) console.warn("offcanvasBottom element not found in DOM.");
  }
})();
